<div class="water-router-wrapper">
  <router-outlet></router-outlet>  
</div>
